import { gql } from '@apollo/client';

export const SAVE_USER_FAVORITE_ORG_MUTATION = gql`
  mutation saveUserFavoriteOrg($input: SaveUserFavoriteOrgInput!) {
    saveUserFavoriteOrg(input: $input) {
      orgId
      isSaved
    }
  }
`;
